import { compose } from 'redux';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import _isEmpty from 'lodash/isEmpty';

import { withForm } from 'components/Form';
import { CLASS_DISABLED_REASON } from 'constants/logic';
import Segment from 'helpers/segment';
import { selectActiveVenueId } from 'selectors/general';

import { enableSchedule } from '../YieldManagement.saga';
import EmptyDetail from './EmptyDetail';

const mapStateToProps = (state, ownProps) => {
  const venueId = selectActiveVenueId(state);
  const { isLoading, schedule = {}, ...restOwnProps } = ownProps;
  const { isFull, scheduleId, spots, isWellness } = schedule;
  const { smartspotRecommendedSpots } = spots || {};
  const formName = `reenable-schedule-${scheduleId}`;
  // treat both null (no recommendation) and recommendation of 0 as no recommendation
  const hasSmartSpotRecommendation = Boolean(smartspotRecommendedSpots);
  const defaultInitialClasspassSpots = isWellness ? 1 : 2;
  const initialClasspassSpots = hasSmartSpotRecommendation ? smartspotRecommendedSpots : defaultInitialClasspassSpots;
  const { classpassSpots: currentClasspassSpots } = getFormValues(formName)(state) || {};

  return {
    ...restOwnProps,
    isLoading,
    hasScheduleData: !_isEmpty(schedule),
    isFull,
    name: formName,
    initialValues: {
      classpassSpots: initialClasspassSpots,
    },
    currentClasspassSpots: currentClasspassSpots || initialClasspassSpots,
    schedule,
    venueId,
    hasSmartSpotRecommendation,
  };
};

const mapDispatchToProps = {
  dispatchEnableSchedule: enableSchedule,
  setField: change,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { schedule, venueId, name: formName, currentClasspassSpots, ...restStateProps } = stateProps;
  const { scheduleClass = {}, scheduleId, smartspotEnabled } = schedule;
  const { classDisabled, disabledReason } = scheduleClass;
  const classDisabledDueToPricingOptions = disabledReason === CLASS_DISABLED_REASON.INVALID_PRICING_OPTION;
  const { dispatchEnableSchedule, setField } = dispatchProps;

  return {
    schedule,
    currentClasspassSpots,
    name: formName,
    classDisabledDueToPricingOptions,
    ...restStateProps,
    decrementClasspassSpots: setField.bind(null, formName, 'classpassSpots', currentClasspassSpots - 1),
    incrementClasspassSpots: setField.bind(null, formName, 'classpassSpots', currentClasspassSpots + 1),
    onSubmit: (values, formAsyncFns) => {
      const { classpassSpots = null } = values;
      const { resolveSubmit } = formAsyncFns;
      Segment.event('Schedule Enabled', { venueId, scheduleId, spotsAdded: classpassSpots });
      dispatchEnableSchedule(venueId, schedule, classDisabled, smartspotEnabled, classpassSpots, resolveSubmit);
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps, mergeProps), withForm())(EmptyDetail);
